import { combineReducers } from 'redux'
import createListReducer, { createActions } from '@app-store/slices/editList/create'
import listReducer, { listActions } from '@app-store/slices/editList/list'
import oneReducer, { oneActions } from '@app-store/slices/editList/one'
import editReducer, { editActions } from '@app-store/slices/editList/edit'
import publishListReducer, { publishListActions } from '@app-store/slices/editList/publishList'
import prePublishListReducer, { prePublishListActions } from '@app-store/slices/editList/prePublishList'
import deleteEditListReducer, { deleteEditListActions } from '@app-store/slices/editList/delete'

export const editListReducers = combineReducers({
    create: createListReducer,
    list: listReducer,
    edit: editReducer,
    one: oneReducer,
    publishList: publishListReducer,
    prePublishList: prePublishListReducer,
    delete: deleteEditListReducer
})

export const editListActions = {
    create: createActions,
    list: listActions,
    edit: editActions,
    one: oneActions,
    publishList: publishListActions,
    prePublishList: prePublishListActions,
    delete: deleteEditListActions
}
